<template lang="">
  <div class="container">
    <div class="spinner"></div>Loading...
  </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.container{
  display:flex;
  justify-content: center;
  align-items: center;
  color:#125a3e;
  font-weight: 900;
}
    .spinner {
  --size: 30px;
  --first: #ffc695;
  --second: #125a3e;
  width: 100px;
  height: 100px;
  position: relative;
  animation: spin 3s linear infinite;
}

.spinner::before,
.spinner::after {
  content: "";
  width: var(--size);
  height: var(--size);
  border: 4px solid var(--first);
  border-top: 4px solid var(--second);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: spinRing 1.5s ease-out infinite;
  box-shadow: 0 0 10px var(--first);
}

.spinner::before {
  filter: blur(10px);
}

@keyframes spinRing {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
    
</style>